import { ElementRef } from '@angular/core';
import { Logger } from '@unleash-tech/js-logger';
import { GlobalErrorHandler } from 'src/app/global-error-handler';
import { ResultsItemContextMenuHelper, ContextMenuInvokeSource } from 'src/app/bar/services/commands/results-item-context-menu-helper';
import { ContextMenuService } from '@shared/components';
import { MailCommandBuilderParams, MailCommandBuilderService } from './mail-command-builder.service';
import { Commands, Search } from '@local/client-contracts';
import { ResultCommandBuilderParams } from '../../results/services/result-command-builder.service';
import { ResourcesService } from '@shared/services/resources.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { WorkspacesService } from 'src/app/bar/services';
import { FlagsService } from '@shared/services/flags.service';

export type KeyValueType = { key: string; value: string };

export class MailContextMenuHelper extends ResultsItemContextMenuHelper {
  constructor(
    builder: MailCommandBuilderService,
    logger: Logger,
    contextMenuService: ContextMenuService,
    hostRef: ElementRef,
    titleRef: ElementRef,
    subtitleRef: ElementRef,
    actionsRef: ElementRef,
    errorHandler: GlobalErrorHandler,
    resourcesService: ResourcesService,
    hubService: HubService,
    flagsService: FlagsService,
    workspacesService: WorkspacesService
  ) {
    super(
      builder,
      logger,
      contextMenuService,
      hostRef,
      titleRef,
      subtitleRef,
      actionsRef,
      errorHandler,
      resourcesService,
      hubService,
      flagsService,
      workspacesService
    );
  }

  async buildItemsRequest(
    state?: Commands.PreviewState,
    model?: Search.ResultResourceItem,
    source?: ContextMenuInvokeSource,
    isPopUp?: boolean,
    previewable = true
  ): Promise<MailCommandBuilderParams> {
    const itemsRequest: ResultCommandBuilderParams = await super.buildItemsRequest(state, model, source, null, previewable);
    let copyEmail: KeyValueType;
    if (model.resource.traits?.sender?.email) {
      copyEmail = { key: 'email', value: model.resource.traits.sender.email };
    }
    return { ...itemsRequest, copyEmail };
  }
}
